// Casa Aragón Owner/Admin Contact Information
export const OWNER_WHATSAPP_NUMBER = '573172885216'; // WhatsApp format (country code + number, no + symbol)
export const OWNER_PHONE_DISPLAY = '+57 317 288 5216'; // Display format for UI

/** Casa Aragón on Google Maps (same link the invitation templates default to). */
export const CASA_ARAGON_MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=CASA+ARAGON&query_place_id=ChIJR5rsZ3Z_Pw4RqRj3lsk';

export const getWhatsAppUrl = (message?: string): string =>
  `https://wa.me/${OWNER_WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
